@for (release of releases; track release) {
  <h3>{{ release.version }} ({{ release.date | date }})</h3>
  @for (group of release.commitGroups; track group) {
    @if (group.title) {
      <h4>{{ group.title }}</h4>
      <ul>
        @for (commit of group.commits; track commit) {
          <li>
            {{ commit.subject }}
            @if (commit.scope) {
              &mdash; <strong>({{ commit.scope }})</strong>
            }
          </li>
        }
      </ul>
    }
  }
}
